import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  style: {
    "width": "100%"
  }
};
import { listProfiles } from '@/api/system/user';
import { Plus } from '@element-plus/icons-vue';
import UserInfoDialog from './UserInfoDialog.vue';

import { ref, watch, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'UserSelector',
  props: {
    placeholder: {
      default: '请选择'
    },
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var userInfoDialog = ref();
    var selectRows = ref([]);
    var options = ref([]);
    watch(function () {
      return props.modelValue;
    }, function () {
      selectRows.value = props.modelValue || [];
      if (props.modelValue && props.modelValue.length > 0) {
        var loadIds = [];
        props.modelValue.forEach(function (item) {
          var i = options.value.find(function (i) {
            return i.id === item;
          });
          if (!i) {
            loadIds.push(item);
          }
        });
        if (loadIds.length > 0) {
          listProfiles(props.modelValue).then(function (res) {
            if (res.data) {
              var _options$value;
              (_options$value = options.value).push.apply(_options$value, _toConsumableArray(res.data));
            }
          });
        }
      }
    }, {
      immediate: true
    });
    var value = computed({
      get: function get() {
        return props.modelValue || [];
      },
      set: function set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    function select(rows) {
      options.value = _toConsumableArray(rows);
      selectRows.value = rows.map(function (item) {
        return item.id;
      });
      emits('update:modelValue', selectRows.value);
    }
    function selectUser() {
      var _userInfoDialog$value;
      (_userInfoDialog$value = userInfoDialog.value) === null || _userInfoDialog$value === void 0 || _userInfoDialog$value.open();
    }
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_input, {
        placeholder: "Please input",
        class: "input-with-select"
      }, {
        prepend: _withCtx(function () {
          return [_createVNode(_component_el_select, {
            modelValue: _unref(value),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(value) ? value.value = $event : null;
            }),
            placeholder: _ctx.placeholder,
            style: {
              "width": "115px"
            },
            multiple: ""
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), function (item, index) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: index,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128)), _unref(options).length === 0 ? (_openBlock(), _createBlock(_component_el_option, {
                key: 0,
                label: "Tel",
                value: "3"
              }, {
                default: _withCtx(function () {
                  return _cache[1] || (_cache[1] = [_createElementVNode("div", {
                    style: {
                      "text-align": "center"
                    }
                  }, "点击右侧按钮+添加收件人", -1)]);
                }),
                _: 1
              })) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["modelValue", "placeholder"])];
        }),
        append: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: selectUser,
            icon: _unref(Plus)
          }, null, 8, ["icon"])];
        }),
        _: 1
      }), _createVNode(UserInfoDialog, {
        ref_key: "userInfoDialog",
        ref: userInfoDialog,
        onSelect: select,
        "default-select": _unref(selectRows)
      }, null, 8, ["default-select"])]);
    };
  }
});